import React from "react";
import { FiEye, FiCheckCircle, FiTrendingUp } from "react-icons/fi";
import Headshot from "../../images/SPC_CIRHS-SM.png";
import {
  AboutSection,
  LightSection,
  SectionInner,
  ValuesBlock,
  ValuesTitle,
  ValuesIntro,
  CoreValuesGrid,
  CoreValueCard,
  CoreValueIconWrap,
  CoreValueContent,
  CoreValueTitle,
  CoreValueText,
  ValuesStatement,
  CopyBlock,
  Paragraph,
  OwnerGrid,
  OwnerImageWrap,
  OwnerImage,
  OwnerContent,
  OwnerTitle,
  OwnerSubtitle,
} from "./AboutElements";

export const CoreValuesSection = () => {
  return (
    <AboutSection id="about">
      <SectionInner>
        <ValuesBlock>
          <ValuesTitle>
            Our Core <span>Values</span>
          </ValuesTitle>
          <ValuesIntro>
            Values that keep work focused, priorities clear, and momentum moving
            forward.
          </ValuesIntro>
          <CoreValuesGrid>
            <CoreValueCard>
              <CoreValueIconWrap aria-hidden="true">
                <FiEye />
              </CoreValueIconWrap>
              <CoreValueContent>
                <CoreValueTitle>Clarity</CoreValueTitle>
                <CoreValueText>
                  Simple priorities and plain language so teams know what to do
                  next.
                </CoreValueText>
              </CoreValueContent>
            </CoreValueCard>

            <CoreValueCard>
              <CoreValueIconWrap aria-hidden="true">
                <FiCheckCircle />
              </CoreValueIconWrap>
              <CoreValueContent>
                <CoreValueTitle>Ownership</CoreValueTitle>
                <CoreValueText>
                  One accountable partner who follows through from plan to
                  outcomes.
                </CoreValueText>
              </CoreValueContent>
            </CoreValueCard>

            <CoreValueCard>
              <CoreValueIconWrap aria-hidden="true">
                <FiTrendingUp />
              </CoreValueIconWrap>
              <CoreValueContent>
                <CoreValueTitle>Evolution</CoreValueTitle>
                <CoreValueText>
                  Continuous improvements as your tools, people, and goals
                  change.
                </CoreValueText>
              </CoreValueContent>
            </CoreValueCard>
          </CoreValuesGrid>
        </ValuesBlock>

        <CopyBlock>
          <ValuesStatement>
            Shift IT helps professional services teams turn IT into a clear
            advantage. We reduce overhead, align with priorities, and eliminate
            distractions so knowledge workers stay focused. The result is fewer
            missed opportunities and more value for each hour of your time.
          </ValuesStatement>
        </CopyBlock>
      </SectionInner>
    </AboutSection>
  );
};

export const OwnerSection = () => {
  return (
    <LightSection>
      <SectionInner>
        <OwnerGrid>
          <OwnerImageWrap>
            <OwnerImage src={Headshot} alt="Sean P. Cook" />
          </OwnerImageWrap>
          <OwnerContent>
            <OwnerTitle>Sean P. Cook</OwnerTitle>
            <OwnerSubtitle>About the Owner</OwnerSubtitle>
            <CopyBlock as="div" $maxWidth="580px">
              <Paragraph>
                Sean founded Shift IT to change how small businesses experience
                IT. Think of him as your virtual CIO, aligning tech strategy to
                drive results.
              </Paragraph>

              <Paragraph>
                He leads engagements end-to-end and brings in partners only when
                specialized work is needed.{" "}
                <a
                  href="https://outlook.office.com/bookwithme/user/bb51bbe3bc3d4e3eb0635e8990c6ad0b@shift-it.io?anonymous&ep=plink"
                  style={{ color: "#ffcb66", textDecoration: "underline" }}
                >
                  Book a 15-minute Fit Check
                </a>{" "}
                to meet Sean and get clear priorities for next steps that make
                sense.
              </Paragraph>
            </CopyBlock>
          </OwnerContent>
        </OwnerGrid>
      </SectionInner>
    </LightSection>
  );
};

const About = () => {
  return (
    <>
      <CoreValuesSection />
      <OwnerSection />
    </>
  );
};

export default About;
